@defer (when !isLoading()) {
    @if (layers().length) {
        <app-custom-table
            [columns]="tableColumns"
            (sortEvent)="sort($event)">
            @for (layer of layers(); track layer.id) {
                <tr
                    [class.details-opened]="layer.id === currentPanelEntity()"
                    (click)="detailPanelService.toggleLayerEntityDetailPanel(layer.id)">
                    <td class="table-raw-padding min-w-25">{{ layer.name }}</td>
                    <td class="table-raw-padding min-w-25">
                        {{
                            layer.deposit && deposits().has(layer.deposit)
                                ? deposits().get(layer.deposit)?.depositFolder?.name
                                : '-'
                        }}
                    </td>
                    <td class="table-raw-padding min-w-25">
                        {{
                            layer.deposit && deposits().has(layer.deposit)
                                ? deposits().get(layer.deposit)?.version
                                : '-'
                        }}
                        <fa-icon
                            class="ml-1"
                            size="lg"
                            [icon]="['fas', layer.versionLock ? 'lock' : 'lock-open']" />
                    </td>
                    <td class="table-raw-padding min-w-25">
                        {{
                            layer.deposit && deposits().has(layer.deposit)
                                ? deposits().get(layer.deposit)?.standard?.name
                                : '-'
                        }}
                    </td>
                    @if (geomOnly()) {
                        <td class="table-raw-padding min-w-25">{{ layer.order }}</td>
                        <td class="table-raw-padding min-w-25">{{ (layer.isVisible ? 'yes' : 'no') | transloco }}</td>
                    }
                </tr>
            }
        </app-custom-table>
    } @else {
        <app-no-data-to-display
            displayedMessage="noDataToShow"
            iconSize="3x" />
    }
} @placeholder (minimum 500ms) {
    <div class="min-h-45 min-w-full flex items-center justify-center">
        <app-loading />
    </div>
}
<div>
    <app-pagination-footer-template
        [canSearch]="false"
        [paginationParameters]="paginationParameters()"
        [searchDisabled]="true"
        [totalEntities]="paginationParameters().totalItems"
        (onPageChange)="onPageChange($event)"
        (paginator)="onPaginatorChange($event)" />
</div>
